export default "__VITE_ASSET__CScNKzro__"